import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar, Footer, ScrollToTop } from './UI.jsx';

export const Layout = () => {
  return (
    <div className="min-h-screen overflow-x-clip bg-[#F1E5DC] font-sans text-[#090807] selection:bg-[#A8814E] selection:text-white">
        <ScrollToTop />
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
  );
};
